export const RESUME_LEARNING_STRINGS = {
  PICK_UP_LEARNING_TITLE :' Pick up where you left off',
  BUTTON_TEXT: 'Resume',
  TAG_TEXT: 'COURSE'
};
